import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Table } from 'react-bootstrap';
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import { FiShare2 } from 'react-icons/fi';


import { useToast } from '~/hooks/toast';
import Index from '~/pages/Index';
import Loading from '~/components/Loading';
import * as S from './styles';
import { useShowMusicDetailsQuery } from '../../graphql/generated/graphql';

const RecordedMusicDashboard = () => {
  const { key } = useParams();
  const { addToast } = useToast();
  // const [dataMusic, setDataMusic] = useState();
  // const [MP3, setMP3] = useState();
  // const [extension, setExtension] = useState();
  // const [musicDownload, setMusicDownload] = useState();
  // const [musicRegister, setMusicRegister] = useState();
  // const [loading, setLoading] = useState(true);
  const navigate = useNavigate();


  const { data: dataMusics, loading: loadingMusics, error: errorMusics } = useShowMusicDetailsQuery({
    variables: {
      data: String(key)
    },
  });

  const profile = dataMusics?.showMusicDetails.profile
  const music = dataMusics?.showMusicDetails.music


  useEffect(() => {
    if (errorMusics) {
      navigate('/dashboard/inicio/resumo');

      addToast({
        type: 'error',
        title: 'Música não encontrada',
        description: 'Erro ao tentar acessar a música',
      });
    }
  }, [errorMusics, navigate, addToast]);

  // useEffect(() => {
  //   if (key) {
  //     api
  //       .get(`/music/show/${key}`)
  //       .then(res => {
  //         setDataMusic(res.data);

  //         const type = res.data.file.name.split('.').pop();

  //         setExtension(type);

  //         setLoading(false)
  //         if (res.data.linkStream) {
  //           const urlStream = `${process.env.REACT_APP_URL_API}/api/v1/guest/music/stream/${res.data.key}`;
  //           const handleDownloadMusic = `${process.env.REACT_APP_URL_API}/api/v1/guest/music/stream/${res.data.key}`;

  //           setMP3(urlStream);
  //           setMusicDownload(handleDownloadMusic);
  //           setMusicRegister(urlMusicRegister);
  //         }
  //         // addToast({
  //         //   type: 'success',
  //         //   title: `message`,
  //         //   description: `Faça login com o email e sua senha`,
  //         // });
  //       })
  //       .catch(error => {
  //         // const { message } = error.response.data;
  //         setLoading(false)

  //         history.push('/dashboard/inicio/resumo');

  //         addToast({
  //           type: 'error',
  //           title: `Música não encontrada`,
  //           description: `Erro ao tentar acessar a música`,
  //         });
  //       });
  //   }
  // }, [key, addToast, history]);

  const downloadMusic = (linkAudio) => {
    window.open(linkAudio, '_blank');
  };

  const urlMusicRegister = `${process.env.REACT_APP_URL}/musica-registrada/${key}`;
  const sharedMusic = () => {
    window.open(`http://api.whatsapp.com/send?text=${urlMusicRegister}`, '_blank');
  };

  function formatPhone(phone) {
    if (!phone) return '';
    return phone.replace(/\D/g, '').replace(/^55/, '').replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3');
  }

  return (
    <Index>
      {!loadingMusics && music && profile ? (
        <>
        <S.Header>
          <div className="nameMusic">
            <h1>{music.title}</h1>
            <span>{music.style}</span>
          </div>
          <div className="author">
            {profile.avatar !== null && (
              <div className="holder">
                <img src={profile.avatar} alt="Foto do compositor" />
              </div>
            )}
            <div>
              <span>Música de</span>
              <h1>{profile.name}</h1>
              <span className="contact">
                Contato: {formatPhone(profile.phone)}
              </span>
            </div>
          </div>
        </S.Header>
        <S.BackgroundSection>
          <div
            className="align"
          >
            <div className="share">
              <button type="button" aria-label="Compartilhar música" onClick={sharedMusic}>
                Compartilhar
                <FiShare2 size={20} />
              </button>
            </div>

            <Table borderless>
              <tbody>
                <tr>
                  <td className="leftItens">
                    <span className="nameMusic">{music.title}</span>
                    <span className="nameComposer">
                      {profile.name} (Autor)
                    </span>
                    {music.co_author.map((co) => (
                      <span key={`coauthor-${co.id}-${Math.random()}`} className="nameComposer">
                        {co.name} (Coautor)
                      </span>
                    ))}
                    {music.interpreter.map((co) => (
                      <span key={`interpreter-${co.id}-${Math.random()}`} className="nameComposer">
                        {co.name} (Intérprete)
                      </span>
                    ))}
                  </td>
                  {!music.files || music.files.extension === 'txt' ? (
                    <td>
                      <span>Composição sem áudio</span>
                    </td>
                  ) : (
                    <>
                      <td className="audioPlay">
                        <AudioPlayer
                          layout="horizontal"
                          customAdditionalControls={[]}
                          showJumpControls={false}
                          customVolumeControls={[]}
                          src={dataMusics.showMusicDetails.linkAudio}
                        />
                      </td>
                      <td className="iconDownloadMusic">
                        <button type="button" onClick={() => downloadMusic(dataMusics.showMusicDetails.linkAudio)}>
                          Baixar
                        </button>
                      </td>
                    </>
                  )}
                </tr>
              </tbody>
            </Table>
            <div className="letterMusic">
              <span>LETRA:</span>
              {music.letter.map((letra, index) => (
                letra !== '' ?
                  <p key={`letter-${index}-${Math.random()}`}>
                    {letra}
                  </p>
                :
                  <br key={`break-${index}-${Math.random()}`}/>
              ))}
            </div>
          </div>
        </S.BackgroundSection>
      </>
      ) : <Loading />}
    </Index>
  );
};

export default RecordedMusicDashboard;
